import type { RouteRecordRaw } from 'vue-router';

export const appointmentsRoutes: RouteRecordRaw[] = [
  {
    path: 'appointments',
    name: 'appointments',
    component: () => import('./pages/AppointmentsCalendarPage.vue'),
    meta: { title: 'Calendar', requiresAuth: true, permission: 'view_service_orders' },
  },
];
